export const VIDEO_ROUTES = {
	ROOM: "/video/:entityType/:entityId",
} as const;
